import { createLogger } from "logging";
import React from "react";
import xss from "xss";

const logger = createLogger("helpers/utils");

export function trimStart(s: string, trim: string) {
  let r = s;
  if (r.startsWith(trim)) {
    r = r.substring(trim.length);
  }
  if (r !== s) {
    logger.trace(`trimStart(): ${s} -> ${r}`);
  }
  return r;
}

export function trimEnd(s: string, trim: string) {
  let r = s;
  if (r.endsWith(trim)) {
    r = r.substring(0, s.length - trim.length);
  }

  if (r !== s) {
    logger.trace(`trimEnd(): ${s} -> ${r}`);
  }
  return r;
}

export function stripHtmlTags(html: string | null | undefined): string {
  if (!html) {
    return "";
  }

  const safeHtml = xss(html);
  const doc = new DOMParser().parseFromString(safeHtml, "text/html");
  const text = doc.body.textContent || "";
  if (text !== html) {
    logger.trace(`stripHtmlTags(): ${html} -> ${text}`);
  }
  return text;
}

export function htmlEncode(s: string) {
  let r = xss(s || "");
  if (!r) {
    return "";
  }

  r = r.replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/ /gi, "&#32;");
  if (r !== s) {
    logger.trace(`htmlEncode(): ${s} -> ${r}`);
  }

  return r;
}

export function getCleanedPath(path: string): string {
  // Remove all '/' at the start
  return path.replace(/^\/+/, "");
}

export function getTruncatedText(text: string, maxLength: number): string {
  return text.length > maxLength ? text.substring(0, maxLength - 13) + "…" : text;
}

export function sanitizeValue(input: unknown): string {
  const type = getType(input);

  switch (type) {
    case "jsx":
      return input as string;
    case "object":
      return JSON.stringify(input);
    case "array":
      return JSON.stringify(input);
    default: {
      const s = `${input || ""}`;
      return sanitizeTrim(s);
    }
  }
}
export function toCamelCase(input: string) {
  let r = `${input}`;
  r = r.replace(/(?:^\w|[A-Z]|\b\w)/g, (x, i) => (i === 0 ? x.toLowerCase() : x.toUpperCase())).replace(/\s+/g, "");
  if (input !== r) logger.trace(`toCamelCase(): `, input, r);

  return r;
}

export function camelToDash(input: string) {
  let r = sanitizeTrim(input);
  r = r.replace(/(^[A-Z])/, ([x]) => x.toLowerCase()).replace(/([A-Z])/g, ([x]) => `-${x.toLowerCase()}`);
  logger.trace(`camelToDash(): ${input} -> ${r}`);

  return r;
}

export function sanitizeTrim(input: string | undefined) {
  let r = input || "";
  r = r.trim();
  if (input !== r) logger.trace(`sanitizeTrim(): `, input, r);

  return r;
}

export function getType(target: unknown) {
  if (!target) return "undefined";

  if (React.isValidElement(target)) {
    return "jsx";
  }

  return Object.getPrototypeOf(target).constructor.name.toLowerCase();
}
